import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, ClockIcon } from 'lucide-react';
import { TradingViewChart } from './TradingViewChart';
export function HeroTerminal() {
  return <section id="terminal" className="border-b border-line" data-id="element-8" data-mp="2af3oxjdsbf9s">
      <div className="mx-auto w-full max-w-[1400px] px-6 pb-16 pt-16 lg:px-10 lg:pb-20 lg:pt-24" data-id="element-9" data-mp="2ahpz7qs288vp">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end" data-id="element-10" data-mp="25ilr73gvgh6y">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-8" data-id="element-11" data-mp="325i037ueydhr">
            <div className="mb-6 flex items-center gap-3" data-id="element-12" data-mp="2tcd8r1n0uurk">
              <span className="h-px w-8 bg-cyan-vip" data-id="element-13" data-mp="2oebuqv4gdlmy" />
              <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-cyan-vip" data-id="element-14" data-mp="3luscocyv4ibn">
                Protocolo de Apertura VIP
              </span>
            </div>
            <h1 className="max-w-4xl text-[40px] font-bold leading-[0.98] tracking-[-0.035em] text-white sm:text-6xl lg:text-[76px]" data-id="element-15" data-mp="3h1z8prb7xe0m">
              <span className="text-glow-white" data-id="element-16" data-mp="2yp6sju0az2da">La Precisión no es</span>{' '}
              <span className="text-white/35" data-id="element-17" data-mp="2yratq46thn9v">una opinión.</span>
              <br data-id="element-18" data-mp="2kxjwnva9vvv1" />
              <span className="text-glow-gold text-gold-vip" data-id="element-19" data-mp="2kvz245nykcx6">
                Es una regla matemática.
              </span>
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="lg:col-span-4" data-id="element-20" data-mp="2ayua3p7fln8g">
            <p className="max-w-md text-[15px] leading-relaxed text-white/55" data-id="element-21" data-mp="261u4ffehumhv">
              Bienvenido a la Terminal de indicadoresvip.com. Monitorea el
              XAU/USD en tiempo real y aplica el Protocolo de Apertura VIP.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.985
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="neon-underlight relative isolate mx-auto mt-14 w-full max-w-[1000px]" data-id="element-22" data-mp="1d6w392iihc2q">
          <div className="neon-edge overflow-hidden rounded-lg border border-cyan-vip/20 bg-ink-800" data-id="element-23" data-mp="z74rz9jdq9sf">
          <div className="flex flex-wrap items-center justify-between gap-3 border-b border-line px-4 py-3" data-id="element-24" data-mp="1vxdpco8u99f4">
            <div className="flex items-center gap-3" data-id="element-25" data-mp="1rv0n49tavtn3">
              <span className="relative flex h-2 w-2" data-id="element-26" data-mp="1rxmtw78da549">
                <span className="absolute inline-flex h-full w-full rounded-full bg-cyan-vip opacity-60" data-id="element-27" data-mp="1n3inpq6xe148" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-cyan-vip" data-id="element-28" data-mp="1i4o4wo8ykck4" />
              </span>
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-vip" data-id="element-29" data-mp="2fmei6niu63br">
                Live · OANDA:XAUUSD
              </span>
            </div>
            <div className="flex items-center gap-5 font-mono text-[11px] text-white/40" data-id="element-30" data-mp="2i62lznho2vf4">
              <span className="inline-flex items-center gap-1.5" data-id="element-31" data-mp="2n3kp2x906gf7">
                <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-32" data-mp="2n6757l9ym491" />
                New York · 15M
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-33" data-mp="2w5k79svr7qjq">
                <ActivityIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-34" data-mp="2w2pmu1cqq5qb" />
                Trading Sessions
              </span>
            </div>
          </div>

            <div className="bg-ink p-2" data-id="element-35" data-mp="361xabhd6vgr5">
              <TradingViewChart data-id="element-36" data-mp="360vqane73jxa" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}